<div fxLayout="row" fxLayoutAlign="start center">
  <span *ngFor="let item of data; let last = last">
    <a [routerLink]="item.url" *ngIf="item.url">{{item.title}}</a>
    <span *ngIf="!last" class="px-8">/</span>
    <span *ngIf="!item.url">{{item.title}}</span>
  </span>
</div>
